var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('StreamBarcodeReader',{ref:"scanner",on:{"decode":_vm.onDecode}}),_c('div',{staticStyle:{"padding":"20px"}},[_c('a-button',{attrs:{"type":"primary","block":""},on:{"click":_vm.back}},[_c('span',{staticStyle:{}},[_c('a-icon',{attrs:{"type":"play-circle"}}),_vm._v(" Kembali ")],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }